/* eslint-disable */
import {
  Grid,
  TextField,
  Typography,
  Box,
  Button,
  getNativeSelectUtilityClasses,
} from "@mui/material";
import { useState, useEffect } from "react";
import { getArmazonAnteojoSol, getCristalBlock } from "../../services/ArticuloService";
import Message from "../../utils/Message";
import { id } from "date-fns/locale";
import { limpiaCodigo } from "../../utils/utils";

const initialData = {
  codigoArticulo: "",
  idArticulo: "",
  descripcionArticulo: "",
};

//
// ###########################################################################
//
const AgregarArticulo = (props) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [tipoArticulo, setTipoArticulo] = useState("");
  const [labelArticulo, setLabelArticulo] = useState("");
  const [labelDescripcion, setLabelDescripcion] = useState("");
  const [agregarArticuloDisabled, setAgregarArticuloDisabled] = useState(false);
  const [quitarArticuloDisabled, setQuitarArticuloDisabled] = useState(true);
  const [data, setData] = useState(initialData);
  //
  // ################################################################################
  //
  useEffect(() => {
    let _tipoArticulo = "";
    let _labelArticulo = "";
    let _labelDescripcion = "";

    if (props.tipoArticulo === "armazon-anteojo-sol") {
      _tipoArticulo = "Armazón / Anteojo de Sol";
      _labelArticulo = "Código Arm/Asol";
      _labelDescripcion = "Código - Descripción - Marca - Modelo";
    } else if (props.tipoArticulo === "cristal-block-od") {
      _tipoArticulo = "Cristal/Block para ojo Derecho";
      _labelArticulo = "Código Cristal/Block";
      _labelDescripcion = "Descripción de Cristal/Block para OD";
    } else if (props.tipoArticulo === "cristal-block-oi") {
      _tipoArticulo = "Cristal/Block para ojo Izquierdo";
      _labelArticulo = "Código Cristal/Block";
      _labelDescripcion = "Descripción de Cristal/Block para OI";
    }
    setTipoArticulo(_tipoArticulo);
    setLabelArticulo(_labelArticulo);
    setLabelDescripcion(_labelDescripcion);
  }, []);
  //
  // ################################################################################
  //
  const handleLimpiarArticulo = () => {
    setData({
      ...data,
      codigoArticulo: "",
      idArticulo: "",
      descripcionArticulo: "",
    });
    props.onAgregarQuitarArticulo("quitar", null);
    setAgregarArticuloDisabled(false);
    setQuitarArticuloDisabled(true);
  };
  //
  // ################################################################################
  //
  const handleBuscarArticulo = () => {

    if (data.codigoArticulo === "") {
      return;
    }

    setData({
      ...data,
      codigoArticulo: limpiaCodigo(data.codigoArticulo).toUpperCase(),
    });

    buscarArticulo(data.codigoArticulo);
  };
  //
  // ################################################################################
  //
  const buscarArticulo = async (parCodigoArticulo) => {
    let response = null;

    setIsDoingSomething(true);
    if (props.tipoArticulo === "armazon-anteojo-sol") {
      let _params = {
        codigo: parCodigoArticulo,
        id_area: localStorage.getItem("id_area_deposito"),
        valida_existencia: 'S',
      };
      response = await getArmazonAnteojoSol(_params);
    } else if (
      props.tipoArticulo === "cristal-block-od" ||
      props.tipoArticulo === "cristal-block-oi"
    ) {
      let _params = {
        codigo: parCodigoArticulo,
        valida_existencia: 'S',
      };
      response = await getCristalBlock(_params);
    }
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data[0];

      if (props.tipoArticulo === "armazon-anteojo-sol") {
        let _armazonAsol =
          _response.codigo +
          " - " +
          _response.descripcion +
          " - " +
          _response.descripcion_ar_as_marca +
          " - " +
          _response.modelo;

        setData({
          ...data,
          idArticulo: _response.id,
          descripcionArticulo: _armazonAsol,
        });
      } else if (
        props.tipoArticulo === "cristal-block-od" ||
        props.tipoArticulo === "cristal-block-oi"
      ) {
        let _cristalBlock =
          _response.codigo + " - " + _response.descripcion + " - " + _response.modelo;

        setData({
          ...data,
          idArticulo: _response.id,
          descripcionArticulo: _cristalBlock,
        });
      }
      props.onAgregarQuitarArticulo("agregar", _response.id, props.tipoArticulo === "cristal-block-od" ? "OD" : "OI");
      setAgregarArticuloDisabled(true);
      setQuitarArticuloDisabled(false);
    } else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
      handleLimpiarArticulo();
      return;
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      {data && (
        <Box sx={{ p: 0 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography component="div" gutterBottom align="left" sx={{ fontWeight: "bold" }}>
                Nuevo {tipoArticulo}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="codigoArticulo"
                label={labelArticulo}
                size="small"
                sx={{ width: "100%", mr: 1 }}
                inputProps={{ style: { textAlign: "left" } }}
                name="codigoArticulo"
                value={data.codigoArticulo}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={10} lg={10}>
              <Button
                sx={{ mr: 1, backgroundColor: "warning" }}
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleBuscarArticulo}
                disabled={agregarArticuloDisabled}
              >
                Agregar a bandeja
              </Button>

              <Button
                sx={{ mr: 1 }}
                variant="outlined"
                size="small"
                onClick={handleLimpiarArticulo}
                disabled={quitarArticuloDisabled}
              >
                Quitar de bandeja
              </Button>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                id="descripcionArticulo"
                label={labelDescripcion}
                sx={{ mb: 1, width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                variant="outlined"
                size="small"
                name="descripcion_articulo"
                value={data.descripcionArticulo || ""}
                disabled
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default AgregarArticulo;
